<template>
  <v-layout>
    <v-flex>
      <panel :title="$t('siteDetails.editSite')">
        <v-text-field
          :title="$t('siteGenerics.siteName')"
          required
          :rules="[required]"
          v-model="site.site_name"
        ></v-text-field>

        <v-text-field
          :title="$t('siteGenerics.siteDescr')"
          required
          :rules="[required]"
          v-model="site.description"
        ></v-text-field>
        <timezone-selector :defaultTimezone="site.time_zone" @timezoneSelected="tz => {site.time_zone = tz.timezone, site.country = tz.country}"/>
        <v-text-field
          :label="$t('siteGenerics.voluntaryPeriod')"
          required
          type="number"
          :rules="[required]"
          v-model="site.voluntary_period"
        ></v-text-field>
        <!-- <v-text-field
          :label="$t('siteGenerics.checkPregnantCow')"
          required
          :rules="[required]"
          v-model="site.checkPregnantCow"
        ></v-text-field> -->
        <sensitivity-selector :defaultSensitivity="site.sensitivity" :sensitivities="['OFF', 'LOW', 'MEDIUM', 'HIGH']" @sensitivitySelected="s => {site.sensitivity = s.sensitivity}"/>
        <v-select
          :items="incrDecrOptions"
          v-model="site.inc_dec_activity_alerts"
          item-text="name"
          item-value="value"
          :label="$t('siteGenerics.incDecActivityAlerts')"
          >
        </v-select>
        <v-checkbox v-model="site.is_seasonal_breeding" :label="$t('siteGenerics.isSeasonalBreeding')"></v-checkbox>
        <v-layout mb-3>
          <v-flex align-self-center xs6>
            <v-layout>
              <v-select
                v-if="site.is_seasonal_breeding"
                :label="$t('graph.from')"
                :items="months"
                v-model="site.sb_from_month"
                @change="updateDaysFrom"
              />
              <v-select
                v-if="site.is_seasonal_breeding"
                :items="daysFrom"
                v-model="site.sb_from_day"
              />
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout mb-3>
          <v-flex align-self-center xs6>
            <v-layout>
              <v-select
                v-if="site.is_seasonal_breeding"
                :label="$t('graph.to')"
                :items="months"
                v-model="site.sb_to_month"
                @change="updateDaysTo"
              />
              <v-select
                v-if="site.is_seasonal_breeding"
                :items="daysTo"
                v-model="site.sb_to_day"
              />
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="danger-alert" v-if="error">
          {{error}}
        </div>
        <v-layout class="modal-button-row">
        <v-btn
          dark
          block
          class="button-delete button-modal"
          @click="this.delete">
          {{$t('actions.delete')}}
        </v-btn>
        <v-btn
          dark
          block
          class="secondary button-modal"
          @click="save">
          {{$t('actions.saveModifications')}}
        </v-btn>
        </v-layout>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import SitesService from '@/services/SitesService'
import UtilsService from '@/services/UtilsService'

export default {
  props: [
    'selectedId'
  ],
  data () {
    return {
      site: {
        site_id: null,
        site_name: null,
        description: null,
        company_id: null,
        time_zone: null,
        country: null,
        sensitivity: null,
        auto_pregnancy_confirm: null,
        early_check_for_pregnancy: null,
        auto_dismiss: null,
        auto_dismiss_days: null,
        is_seasonal_breeding: null,
        sb_from_month: null,
        sb_to_month: null,
        sb_from_day: null,
        sb_to_day: null,
        sb_from_date: null,
        sb_to_date: null,
        inc_dec_activity_alerts: 'NONE',
      },
      daysFrom: [],
      daysTo: [],
      months: [
        { text: 'January', value: 1, days: 31 },
        { text: 'February', value: 2, days: 28 },
        { text: 'March', value: 3, days: 31 },
        { text: 'April', value: 4, days: 30 },
        { text: 'May', value: 5, days: 31 },
        { text: 'June', value: 6, days: 30 },
        { text: 'July', value: 7, days: 31 },
        { text: 'August', value: 8, days: 31 },
        { text: 'September', value: 9, days: 30 },
        { text: 'October', value: 10, days: 31 },
        { text: 'November', value: 11, days: 30 },
        { text: 'December', value: 12, days: 31 },
      ],
      error: null,
      incrDecrOptions: [
        { name: this.$t('siteGenerics.incrDecrOptions.incrOnly'), value: 'INCR' },
        { name: this.$t('siteGenerics.incrDecrOptions.decrOnly'), value: 'DECR' },
        { name: this.$t('siteGenerics.incrDecrOptions.both'), value: 'BOTH' },
        { name: this.$t('siteGenerics.off'), value: 'NONE' }
      ],
      required: (value) => !!value || value === 0 || 'Required.',
    }
  },
  methods: {
    async save () {
      this.error = null
      try {
        this.error = null;
        let areAllFieldsFilledIn = true;
        const data = {
          site_id: this.site.site_id,
          site_name: this.site.site_name,
          description: this.site.description,
          company_id: +this.site.company_id,
          time_zone: this.site.time_zone,
          country: this.site.country,
          voluntary_period: +this.site.voluntary_period,
          dry_off: +this.site.dry_off,
          sensitivity: this.site.sensitivity,
          auto_pregnancy_confirm: this.site.auto_pregnancy_confirm,
          auto_dismiss: this.site.auto_dismiss,
          is_seasonal_breeding: this.site.is_seasonal_breeding,
          inc_dec_activity_alerts: this.site.inc_dec_activity_alerts,
          early_check_for_pregnancy: this.site.early_check_for_pregnancy
        }

        if(this.site.auto_dismiss) {
          data['auto_dismiss_days'] = +this.site.auto_dismiss_days;
          if(!data['auto_dismiss_days']) {
            areAllFieldsFilledIn = false;
          }
        }

        if(this.site.is_seasonal_breeding) {
          const year = new Date().getFullYear();

          data['sb_from_date'] = `${year}-${String(this.site.sb_from_month).padStart(2, '0')}-${String(this.site.sb_from_day).padStart(2, '0')}`;
          data['sb_to_date'] = `${year}-${String(this.site.sb_to_month).padStart(2, '0')}-${String(this.site.sb_to_day).padStart(2, '0')}`;

          if(!data['sb_from_date'] || !data['sb_to_date']) {
            areAllFieldsFilledIn = false;
          }
        }

        if (!areAllFieldsFilledIn) {
          this.error = this.$t('mainErrors.fieldsRequired');
          return;
        }

        await SitesService.put(data)
        this.$emit('close') // notify parent to close the modal
      } catch (err) {
        console.log(err)
        this.error = err.response.data
      }
    },
    async delete () {
      try {
        await SitesService.delete(this.site.site_id)
        this.$emit('close') // notify parent to close the modal
      } catch (err) {
        this.error = err.response.data
      }
    },
    updateDaysFrom() {
      const selectedMonth = this.months.find(
        (month) => month.value === this.site.sb_from_month
      );

      this.daysFrom = Array.from({ length: selectedMonth.days }, (_, i) => i + 1);

    },
    updateDaysTo() {
      const selectedMonth = this.months.find(
        (month) => month.value === this.site.sb_to_month
      );
      this.daysTo = Array.from({ length: selectedMonth.days }, (_, i) => i + 1);
    },
  },
  async mounted () {
    try {
      this.error = null
    } catch (err) {
      this.error = err.response.statusText
    }
  },
  watch: {
    'site.sb_from_month': 'updateDaysFrom',
    'site.sb_to_month': 'updateDaysTo',
    selectedId: async function (val) {
      try {
        this.error = null
        const siteID = this.selectedId
        this.site = (await SitesService.show(siteID)).data


        if(this.site.is_seasonal_breeding && this.site.sb_from_date && this.site.sb_to_date){
          const sb_from_date = new Date(this.site.sb_from_date)
          const sb_to_date = new Date(this.site.sb_to_date)

          this.site.sb_from_month = sb_from_date.getMonth() + 1
          this.site.sb_from_day = sb_from_date.getDate()

          this.site.sb_to_month = sb_to_date.getMonth() + 1
          this.site.sb_to_day = sb_to_date.getDate()
        }
      } catch (err) {
        this.error = err.response.statusText
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EditSite.vue